import { MUTES, asDecryptedEvent, readList } from "@welshman/util";
import { deriveEventsMapped } from "@welshman/store";
import { repository } from "./core.js";
import { load } from "./subscribe.js";
import { collection } from "./collection.js";
import { ensurePlaintext } from "./plaintext.js";
import { loadRelaySelections } from "./relaySelections.js";
export const mutes = deriveEventsMapped(repository, {
    filters: [{ kinds: [MUTES] }],
    itemToEvent: item => item.event,
    eventToItem: async (event) => readList(asDecryptedEvent(event, {
        content: await ensurePlaintext(event),
    })),
});
export const { indexStore: mutesByPubkey, deriveItem: deriveMutes, loadItem: loadMutes, } = collection({
    name: "mutes",
    store: mutes,
    getKey: mute => mute.event.pubkey,
    load: async (pubkey, request = {}) => {
        await loadRelaySelections(pubkey, request);
        await load({ ...request, filters: [{ kinds: [MUTES], authors: [pubkey] }] });
    },
});
//# sourceMappingURL=mutes.js.map